// extracted by mini-css-extract-plugin
export default {"spacing":"InsurancePolicy_spacing__tr4Gu"};